import { createContext } from "react";

const SplitPaneContext = createContext();

export default SplitPaneContext;
